import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import _slicedToArray from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.regexp.search";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import _classCallCheck from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import UniversalReport from '@tencent/universal-report';
import atom from '@tencent/vft-atom';
import cookie from '@tencent/vft-common/cookie';
import env from '@tencent/vft-common/env';
import login from '@tencent/vft-common/login';
import { getAIDPlatform as getPlatform } from '@tencent/vft-common/platform';
import storage from '@tencent/vft-common/Storage/session';
import { getUrlParam } from '@tencent/vft-common/util';
import { DEFAULT_BUSINESS } from "../const";
import { EventType } from "../defs";
import { calculateScreenType, getPvid, logger, mapBoss2DtParams, normalizeDtParams, obj2query } from "../util";
var StandardEvent;

(function (StandardEvent) {
  StandardEvent["PGIN"] = "dt_pgin";
  StandardEvent["PGOUT"] = "dt_pgout";
  StandardEvent["IMP"] = "dt_imp";
  StandardEvent["IMPEND"] = "dt_imp_end";
  StandardEvent["CLCK"] = "dt_clck";
})(StandardEvent || (StandardEvent = {}));

var UniversalReporter = /*#__PURE__*/function () {
  function UniversalReporter(options) {
    _classCallCheck(this, UniversalReporter);

    var hardwareOs = env.os;

    if (env.isPCClient) {
      hardwareOs = 'windows';
    } else if (env.isMac) {
      hardwareOs = 'macos';
    }

    var pageId = options.pageId,
        debug = options.debug;
    var contentId = "".concat(pageId, "_init");
    this.pageParams = {
      pgid: pageId,
      contentid: contentId
    };
    this.reporter = new UniversalReport({
      beacon: '0WEB05F90045KVFT',
      // 使用js上报
      channel: 'beacon',
      formatMode: 1,
      contentidSet: _defineProperty({}, pageId, contentId),
      publicParams: {
        // 基础公共参数覆盖
        platform: env.isWeb ? 'pc' : 'phone',
        hardware_os: hardwareOs,
        // 自定义公共参数
        ptag: getUrlParam('ptag') || storage.get('ptag') || cookie.get('ptag'),
        aid: getUrlParam('aid'),
        url: location.href,
        ref_url: document.referrer,
        url_param: location.search.substring(1),
        domain: location.hostname,
        pt: getPlatform(),
        screen_height: window.screen.height,
        screen_width: window.screen.width,
        screen_size_class: calculateScreenType(),
        hh_ua_raw: navigator.userAgent,
        hc_pvid: getPvid()
      },
      bossSet: {
        dt_pgin: {
          AttaId: '08000035396',
          token: '6627225758'
        },
        dt_pgout: {
          AttaId: '0c600035397',
          token: '5338911273'
        },
        dt_imp: {
          AttaId: '07100035402',
          token: '9859947335'
        },
        dt_imp_end: {
          AttaId: '0a100035399',
          token: '1756176621'
        },
        dt_clck: {
          AttaId: '0bb00035401',
          token: '4172841644'
        }
      },
      monitoringReport: debug,
      monitoringReportId: pageId
    });
    this.options = options;
    atom.on('onActionLoginFinish', this.setPublicParams.bind(this));
    atom.on('onActionLogoutFinish', this.setPublicParams.bind(this));
    atom.on('onSwitchLoginStateResponse', this.setPublicParams.bind(this));
  }

  _createClass(UniversalReporter, [{
    key: "ready",
    value: function () {
      var _ready = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$options, buildPageParams, pageRoot, pageId, _this$options$useSdkM, useSdkMode, asyncTasks, _yield$Promise$allSet, _yield$Promise$allSet2, pageParamsResult, root;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$options = this.options, buildPageParams = _this$options.pageParams, pageRoot = _this$options.pageRoot, pageId = _this$options.pageId, _this$options$useSdkM = _this$options.useSdkMode, useSdkMode = _this$options$useSdkM === void 0 ? false : _this$options$useSdkM;

                if (pageId) {
                  _context.next = 4;
                  break;
                }

                logger.error('[UN Report] 请设置你在大同配置的页面id');
                return _context.abrupt("return");

              case 4:
                _context.prev = 4;
                asyncTasks = [this.setPublicParams()];

                if (buildPageParams) {
                  asyncTasks.push(buildPageParams());
                }

                _context.next = 9;
                return Promise.allSettled(asyncTasks);

              case 9:
                _yield$Promise$allSet = _context.sent;
                _yield$Promise$allSet2 = _slicedToArray(_yield$Promise$allSet, 2);
                pageParamsResult = _yield$Promise$allSet2[1];

                if ((pageParamsResult === null || pageParamsResult === void 0 ? void 0 : pageParamsResult.status) === 'fulfilled') {
                  Object.assign(this.pageParams, pageParamsResult.value);
                }

                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](4);
                logger.error(_context.t0);

              case 18:
                // 大同sdk必须传pageRoot，sdk模式下默认创建一个游离的div作为占位符
                root = pageRoot || (useSdkMode ? document.createElement('div') : document.body);
                this.reporter.setPage(_objectSpread({}, this.pageParams), root); // sdk模式下只支持手动上报，不再监听dom

                if (!useSdkMode) {
                  this.reporter.observe(pageId);
                }

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 15]]);
      }));

      function ready() {
        return _ready.apply(this, arguments);
      }

      return ready;
    }()
  }, {
    key: "report",
    value: function report(params) {
      var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EventType.EXPOSE;

      if (!params) {
        throw new Error('[UN Report] 参数不能为空');
      }

      var businessParams = mapBoss2DtParams(params);

      if (!businessParams.business) {
        businessParams.business = DEFAULT_BUSINESS;
      }

      this.reporter.reportEvent({
        pgid: this.options.pageId,
        eventName: event === EventType.CLICK ? StandardEvent.CLCK : StandardEvent.IMP,
        publicParams: {
          dt_eid: params.eid || params.f_hottag
        },
        businessParams: businessParams
      });
    }
  }, {
    key: "useDirective",
    value: function useDirective(el, binding) {
      var params = binding.value,
          type = binding.type;

      if (!params) {
        return;
      }

      el.setAttribute('dt-params', obj2query(normalizeDtParams(params)));

      if (type === EventType.EXPOSE) {
        el.setAttribute('dt-clck-ignore', 'true');
      } else if (type === EventType.CLICK) {
        el.setAttribute('dt-imp-ignore', 'true');
      }

      var eid = params.eid || params.f_hottag;

      if (eid) {
        el.setAttribute('dt-eid', eid);
        el.setAttribute('dt-keep-report', 'true');
      } else if (!el.getAttribute('dt-eid')) {
        logger.warn("[UN Report] \u4E0A\u4F20\u53C2\u6570 ".concat(JSON.stringify(params), " \u4E2D 'eid' \u7F3A\u5931"));
      }
    }
  }, {
    key: "setExtraParams",
    value: function setExtraParams(params) {
      this.reporter.setPublicParams(params);
    }
  }, {
    key: "setPublicParams",
    value: function () {
      var _setPublicParams = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _a, _b, extraParams, _yield$Promise$all, _yield$Promise$all2, baseParams, cookies, cookieParams, mainLogin, appid, vqqAppid, vqqOpenid, openid, loginType, uid;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                try {
                  extraParams = (_b = (_a = this.options).extraParams) === null || _b === void 0 ? void 0 : _b.call(_a);
                } catch (e) {
                  logger.warn('[UniversalReport.setPublicParams] options.extraParams执行异常', e);
                }

                _context2.next = 3;
                return Promise.all([this.buildBaseParams(), atom.getMainCookie()].map(function (result) {
                  return result.catch(function () {
                    return null;
                  });
                }));

              case 3:
                _yield$Promise$all = _context2.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                baseParams = _yield$Promise$all2[0];
                cookies = _yield$Promise$all2[1];
                cookieParams = {
                  appid: '',
                  qq_openid: '',
                  wx_openid: ''
                };

                if (cookies) {
                  mainLogin = cookies.main_login, appid = cookies.appid, vqqAppid = cookies.vqq_appid, vqqOpenid = cookies.vqq_openid, openid = cookies.openid;

                  if (mainLogin === 'qq') {
                    cookieParams.appid = vqqAppid || '';
                    cookieParams.qq_openid = vqqOpenid || '';
                  } else if (mainLogin === 'wx') {
                    cookieParams.appid = appid || '';
                    cookieParams.wx_openid = openid || '';
                  }
                }

                loginType = login.loginType();
                uid = login.getUid();
                this.reporter.setPublicParams(_objectSpread(_objectSpread(_objectSpread({}, cookieParams), {}, {
                  qq: login.isPTLogin() ? uid : '',
                  vuserid: login.getVuid(),
                  main_login: loginType
                }, baseParams), extraParams));

                if (login.isLogin()) {
                  this.reporter.setAccountInfo(_defineProperty({
                    dt_mainlogin_h5: loginType
                  }, "dt_".concat(loginType, "openid_h5"), uid));
                } else {
                  this.reporter.clearAccountInfo();
                }

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setPublicParams() {
        return _setPublicParams.apply(this, arguments);
      }

      return setPublicParams;
    }()
  }, {
    key: "setPageParams",
    value: function setPageParams(params) {
      var override = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var pageId = this.options.pageId;

      if (override) {
        this.pageParams = _objectSpread(_objectSpread({}, params), {}, {
          pgid: pageId,
          contentid: "".concat(pageId, "_init")
        });
      } else {
        Object.assign(this.pageParams, params);
      }

      this.reporter.setPageParams(this.pageParams);
    }
  }, {
    key: "buildBaseParams",
    value: function () {
      var _buildBaseParams = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$Promise$all3, _yield$Promise$all4, _yield$Promise$all4$, version, _yield$Promise$all4$2, _yield$Promise$all4$3, systemVersion, _yield$Promise$all4$4, guid, _yield$Promise$all4$5, qimei36, _yield$Promise$all4$6, omgid, _yield$Promise$all4$7, isJBOS;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.baseParams) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", this.baseParams);

              case 2:
                _context3.next = 4;
                return Promise.all([atom.getAppInfo(), atom.getDeviceInfo()].map(function (result) {
                  return result.catch(function () {
                    return {};
                  });
                }));

              case 4:
                _yield$Promise$all3 = _context3.sent;
                _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
                _yield$Promise$all4$ = _yield$Promise$all4[0].version;
                version = _yield$Promise$all4$ === void 0 ? '' : _yield$Promise$all4$;
                _yield$Promise$all4$2 = _yield$Promise$all4[1];
                _yield$Promise$all4$3 = _yield$Promise$all4$2.systemVersion;
                systemVersion = _yield$Promise$all4$3 === void 0 ? '' : _yield$Promise$all4$3;
                _yield$Promise$all4$4 = _yield$Promise$all4$2.guid;
                guid = _yield$Promise$all4$4 === void 0 ? '' : _yield$Promise$all4$4;
                _yield$Promise$all4$5 = _yield$Promise$all4$2.qimei36;
                qimei36 = _yield$Promise$all4$5 === void 0 ? '' : _yield$Promise$all4$5;
                _yield$Promise$all4$6 = _yield$Promise$all4$2.omgid;
                omgid = _yield$Promise$all4$6 === void 0 ? '' : _yield$Promise$all4$6;
                _yield$Promise$all4$7 = _yield$Promise$all4$2.isJBOS;
                isJBOS = _yield$Promise$all4$7 === void 0 ? '0' : _yield$Promise$all4$7;
                // 合规要求，不允许上报用户imei和idfa
                this.baseParams = {
                  pgid: '',
                  app_vr: version,
                  os_vrsn: systemVersion,
                  guid: guid,
                  qimei36: qimei36,
                  omgid: omgid,
                  jlbrk: isJBOS
                };
                return _context3.abrupt("return", this.baseParams);

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function buildBaseParams() {
        return _buildBaseParams.apply(this, arguments);
      }

      return buildBaseParams;
    }()
  }]);

  return UniversalReporter;
}();

export { UniversalReporter as default };